export const RecordingInformationTrend = {
    NORMAL: 0,
    HIGH: 1,
    LOW: 2,
    NO_DATA: 3
};
